import {Entity, PrimaryGeneratedColumn} from "typeorm/browser";
import {Column} from "typeorm";

@Entity("fitofisionomia")
export class Fitofisionomia{
  @PrimaryGeneratedColumn("uuid")
  id?: string
  @Column()
  nome?: string
  @Column()
  excluido?: boolean
}
